import React, { PureComponent } from 'react';

class CleanCheckAnimation extends PureComponent {
    render() {
        return (
            <div style={styles.container}>
                <style>{keyframes}</style>
                <div style={styles.circleOuter}>
                    <svg style={styles.svg} viewBox="0 0 100 100">
                        <circle
                            cx="50" cy="50" r="40"
                            fill="none"
                            stroke="#4CAF50"
                            strokeWidth="3"
                            strokeDasharray="251"
                            strokeDashoffset="251"
                            style={{ animation: 'check-circle-draw 0.6s ease-out forwards' }}
                        />
                        <polyline
                            points="30,52 45,67 72,37"
                            fill="none"
                            stroke="#4CAF50"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeDasharray="60"
                            strokeDashoffset="60"
                            style={{ animation: 'check-draw 0.4s ease-out 0.5s forwards' }}
                        />
                    </svg>
                </div>
            </div>
        );
    }
}

const keyframes = `
@keyframes check-circle-draw {
    to { stroke-dashoffset: 0; }
}
@keyframes check-draw {
    to { stroke-dashoffset: 0; }
}
`;

const styles = {
    container: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
    },
    circleOuter: {
        width: 150,
        height: 150,
    },
    svg: {
        width: '100%',
        height: '100%',
        filter: 'drop-shadow(0 0 10px rgba(76, 175, 80, 0.5))',
    },
};

export default CleanCheckAnimation;
